import { Menu, MenuProps } from '@chakra-ui/react';
import { createContext, MutableRefObject, ReactNode, useContext, useRef } from 'react';

type MenuSelectContextValue = {
  initialFocusRef: MutableRefObject<Pick<HTMLElement, 'focus'> | null>;
};

const MenuSelectContext = createContext<MenuSelectContextValue | null>(null);

export function MenuSelect({
  autoSelect = true,
  children,
  ...props
}: MenuProps & { children: ReactNode }) {
  const initialFocusRef = useRef<Pick<HTMLElement, 'focus'> | null>(null);

  return (
    <MenuSelectContext.Provider value={{ initialFocusRef }}>
      <Menu isLazy autoSelect={autoSelect} initialFocusRef={initialFocusRef} {...props}>
        {children}
      </Menu>
    </MenuSelectContext.Provider>
  );
}

export function useMenuSelectContext() {
  return useContext(MenuSelectContext);
}
